// ── color.js — подбор цвета текста к фону ──────────────────────────────────
// Текст на цветной плашке должен читаться в любой теме: считаем относительную
// яркость фона (WCAG 2.x) и берём тот из двух цветов, у которого контраст выше.

const channel = (v) => {
  const c = v / 255;
  return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
};

export function luminance(hex) {
  const m = /^#?([0-9a-f]{6})$/i.exec(String(hex).trim());
  if (!m) return 0;
  const n = parseInt(m[1], 16);
  return 0.2126 * channel((n >> 16) & 255) + 0.7152 * channel((n >> 8) & 255) + 0.0722 * channel(n & 255);
}

export function contrast(a, b) {
  const [l1, l2] = [luminance(a), luminance(b)].sort((x, y) => y - x);
  return (l1 + 0.05) / (l2 + 0.05);
}

// Белый или тёмный текст — что контрастнее на этом фоне.
export function readableOn(bg, light = '#ffffff', dark = '#14171f') {
  return contrast(bg, light) >= contrast(bg, dark) ? light : dark;
}

// Тот же цвет темнее: k = 0.4 — на 40 % ближе к чёрному. Для «ребра» объёмной
// кнопки (тема «Аркада»). Не hex (rgba, transparent) — возвращается как есть.
export function shade(hex, k = 0.4) {
  const m = /^#?([0-9a-f]{6})$/i.exec(String(hex).trim());
  if (!m) return hex;
  const n = parseInt(m[1], 16);
  const part = (v) => Math.round(v * (1 - k)).toString(16).padStart(2, '0');
  return `#${part((n >> 16) & 255)}${part((n >> 8) & 255)}${part(n & 255)}`;
}

// Цвет для текста на фоне bg: если fg читается хуже min (3 — крупный текст по WCAG,
// 4.5 — обычный), подмешиваем к нему белое на тёмном фоне или чёрное на светлом,
// пока не станет читаться. Оттенок сохраняется. Так цвет карточки (фиолетовый,
// синий…) остаётся узнаваемым и в тёмных темах, и в «Аркаде».
export function legibleOn(fg, bg, min = 3) {
  const f = /^#?([0-9a-f]{6})$/i.exec(String(fg).trim());
  if (!f || !/^#?[0-9a-f]{6}$/i.test(String(bg).trim()) || contrast(fg, bg) >= min) return fg;
  const n = parseInt(f[1], 16);
  const rgb = [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  const to = contrast(bg, '#ffffff') >= contrast(bg, '#000000') ? 255 : 0; // куда светлее/темнее есть запас
  const hex = (k) => '#' + rgb.map((v) => Math.round(v + (to - v) * k).toString(16).padStart(2, '0')).join('');
  for (let k = 0.05; k < 1; k += 0.05) { const c = hex(k); if (contrast(c, bg) >= min) return c; }
  return to ? '#ffffff' : '#000000';
}

// Надпись на цветной плашке (кнопка, ответ в повторении): { fg, outline }.
// Тема с labelOutline («Аркада») рисует белый текст в тёмной обводке — его видно на сочном
// цвете уже при контрасте 3:1, outline: true включает обводку (атрибут data-outline).
// Иначе — белый или тёмный, что контрастнее, без обводки.
export function labelOn(C, fill) {
  if (C.onAccent && contrast(fill, C.onAccent) >= (C.labelOutline ? 3 : 4.5)) return { fg: C.onAccent, outline: !!C.labelOutline };
  return { fg: readableOn(fill), outline: false };
}
